module.exports = __webpack_public_path__ + "static/media/Search-new.4b00e20a.svg";